/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerCameraConfiguration.yaml
import { PartiallyConstructible } from '../../utils/utils';
export const CapturePhotoQualityPrioritizationValues = [
    'SPEED',
    'BALANCED',
    'QUALITY',
];
/**
Configuration of the camera behavior.
*/
export class DocumentScannerCameraConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentScannerCameraConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Determines which camera module to use on start-up.
          
          Default is BACK
          */
        this.cameraModule = 'BACK';
        /**
          The default zoom factor on start-up.
          
          Default is 1.0
          */
        this.defaultZoomFactor = 1.0;
        /**
          Determines whether the document should be cropped automatically after a manual snap or not.
          
          Default is true
          */
        this.autoCropOnManualSnap = true;
        /**
          Determines whether the flashlight is enabled or not on start-up.
          
          Default is false
          */
        this.flashEnabled = false;
        /**
          Determines whether locking the focus at the minimum possible distance is enabled or not (device-specific).
          
          Default is false
          */
        this.minFocusDistanceLock = false;
        /**
          Determines whether touch-to-focus is enabled or not. Android only.
          
          Default is false
          */
        this.touchToFocusEnabled = false;
        /**
          Determines whether pinch-to-zoom is enabled or not.
          
          Default is true
          */
        this.pinchToZoomEnabled = true;
        /**
          Determines which camera preview mode to use.
          
          Default is FILL_IN
          */
        this.cameraPreviewMode = 'FILL_IN';
        /**
          Determines the prioritization of still image quality and capturing speed.
          
          Default is BALANCED
          */
        this.captureQualityPrioritization = 'BALANCED';
        /**
          Controls the auto snapping speed. The sensitivity must be between 0.0 and 1.0. A value of 1.0 triggers auto snapping immediately, while a value of 0.0 delays the auto snapping by 3 seconds. The default value is 0.66 (2 seconds).
          
          Default is 0.66
          */
        this.autoSnappingSensitivity = 0.66;
        /**
          After a page has been snapped, the delay in milliseconds before auto snapping resumes for the next page.
          
          Default is 200
          */
        this.autoSnappingDelay = 200;
        /**
          Determines if auto snapping is enabled or not.
          
          Default is true
          */
        this.autoSnappingEnabled = true;
        /**
          When enabled the hardware volume up/down buttons can be used to capture an image if manual snapping is enabled. For iOS version 17.2 or later is required. On iPhones with camera control (iPhone 16 series) this also enables zooming and capturing with the camera control.
          
          Default is true
          */
        this.captureWithHardwareButtonsEnabled = true;
        if (source.cameraModule !== undefined) {
            this.cameraModule = source.cameraModule;
        }
        if (source.defaultZoomFactor !== undefined) {
            this.defaultZoomFactor = source.defaultZoomFactor;
        }
        if (source.autoCropOnManualSnap !== undefined) {
            this.autoCropOnManualSnap = source.autoCropOnManualSnap;
        }
        if (source.flashEnabled !== undefined) {
            this.flashEnabled = source.flashEnabled;
        }
        if (source.minFocusDistanceLock !== undefined) {
            this.minFocusDistanceLock = source.minFocusDistanceLock;
        }
        if (source.touchToFocusEnabled !== undefined) {
            this.touchToFocusEnabled = source.touchToFocusEnabled;
        }
        if (source.pinchToZoomEnabled !== undefined) {
            this.pinchToZoomEnabled = source.pinchToZoomEnabled;
        }
        if (source.cameraPreviewMode !== undefined) {
            this.cameraPreviewMode = source.cameraPreviewMode;
        }
        if (source.captureQualityPrioritization !== undefined) {
            this.captureQualityPrioritization = source.captureQualityPrioritization;
        }
        if (source.autoSnappingSensitivity !== undefined) {
            this.autoSnappingSensitivity = source.autoSnappingSensitivity;
        }
        if (source.autoSnappingDelay !== undefined) {
            this.autoSnappingDelay = source.autoSnappingDelay;
        }
        if (source.autoSnappingEnabled !== undefined) {
            this.autoSnappingEnabled = source.autoSnappingEnabled;
        }
        if (source.captureWithHardwareButtonsEnabled !== undefined) {
            this.captureWithHardwareButtonsEnabled = source.captureWithHardwareButtonsEnabled;
        }
    }
}
//# sourceMappingURL=DocumentScannerCameraConfiguration.js.map